/** Terms & Privacy — 日本語。現状は主に1対1；グループ・チャンネル・モデレーションは将来追加の可能性。 */
export const legalDocumentsJa = {
  termsFull: `1. 本規約への同意

アカウントの作成、ログイン、または Duvpost（「本サービス」「当社」）の利用により、本利用規約に同意したものとみなされます。同意しない場合は本サービスを利用しないでください。

2. Duvpost とは

Duvpost はメッセージングおよびリアルタイム通信のウェブアプリケーションで、小規模に運営されます。

現時点では、リアルタイムの 1 対 1 チャット、ファイル添付、個々のユーザー間の音声・ビデオ通話、リンクによる Meet 型のルーム、メール／パスワードまたは Google によるアカウント（例：People の発見・プロフィール）に重点があります。グループ会話、チャンネル、専用のモデレーション・ワークフローは現行ビルドの必須機能ではありませんが、後日お客様との別途合意なしに導入される場合があります。その場合も本規約が適用されます。

機能は随時追加・変更・廃止される場合があります。ここに記載されたすべての機能が、お客様の地域・料金プラン・アプリ版で常に利用できるとは限りません。

本サービスは Google Firebase（Authentication、Firestore、Storage、Cloud Functions および関連インフラ）およびプライバシーポリシーに記載のその他のコンポーネントを使用します。

3. 利用資格

16 歳以上、またはお住まいの国の最低年齢。未成年の場合は保護者の同意が必要です。適用法上の年齢未満の児童から意図的にデータを収集しません。

4. アカウント

正確な情報、安全な認証情報、アカウント下の活動に対する責任。侵害の疑いがある場合は公開されている連絡先からご連絡ください。

有料プラン（例：「Premium」）では、購入時に料金、請求サイクル、税金が表示されます。未払いはダウングレードまたは有料機能の喪失につながる場合があります。

5. プラン、ストレージ制限、保存期間

当社は異なるアカウント階層（例：標準／無料および有料）を提供する場合があります。最大ファイルサイズ、合計ストレージ、同時アップロード数、または一定期間後の添付の自動削除などの制限はプランにより異なり、変更される場合があります。法令上義務がない限り、重要な変更については合理的な範囲で事前通知（アプリ内、メール、または更新された規約など）を試みます。

制限のあるプランでは、当社が示す期間後、または割当超過時にアップロード済みファイルが自動削除される場合があります。上位プランではより大きな上限、長い保存、または制限の緩和が提供される場合があります。「無制限」も公正利用および不正利用防止方針の対象となります。

重要なデータのバックアップはお客様の責任です。現行サービスでは、チャットのメッセージとアップロード済みファイルは作成から 14 日間保存された後、自動削除されます。ユーザー生成コンテンツの無制限かつ無期限の保存を保証するものではありません。

6. ユーザーコンテンツ

お客様はコンテンツに関する権利を保持します。本サービスの運営および保護、本規約の執行、法令遵守に必要な範囲で、ホスティング、保存、複製、送信、表示するための限定的かつ世界的かつ非独占的なライセンスを当社に付与します。1 対 1 チャット、通話、Meet、および提供時にはグループ、チャンネル、関連機能を含みます。

お客様のコンテンツの所有権を当社が主張するものではありません。メッセージ内容は暗号化された状態で保存される場合があります。詳細はプライバシーポリシーをご覧ください。合法性および第三者の権利についてはお客様が責任を負います。グループまたはチャンネルが存在する場合、そこでも適用法および本規約が適用されます。当社は追加ルールを公表する場合があります。

7. 許容される利用

違法、有害、嫌がらせ、差別的な利用、マルウェア／フィッシング、不正アクセス、API の濫用、なりすまし、知的財産またはプライバシーの侵害、スパム、提供される場合にはオープンまたは発見可能なチャンネルおよび類似機能を用いた違法コンテンツの利用などは禁止します。

法令または本規約に基づき、アクセスの停止、コンテンツの削除または制限を行う場合があります。すべてのユーザー通信を監視する一般的義務はありません。通報またはモデレーション機能を導入する場合、その利用が特定の対応時間や結果を保証するものではありません。

8. 通話と第三者インフラ

音声／ビデオ（グループ通話を追加する場合を含む）：P2P または中継（TURN）。ネットワークおよび中継事業者は各自の方針に従い処理します。ブラウザ／OS の権限はお客様が管理します。

9. 第三者サービス

Google／Firebase、決済は各事業者の条件に従う決済プロセッサ。リンクプレビューは第三者サイトにリクエストを送る場合があります。

10. 知的財産

Duvpost の商標およびソフトウェア（お客様のコンテンツを除く）は保護されています。

11. 免責

本サービスは「現状有姿」「利用可能な範囲」で提供されます。法令で認められる限り、明示・黙示・法定的保証のすべてを否認します。商品性、特定目的への適合性、平穏な享受、非侵害を含みます。

無中断・無エラー、欠陥の修正、サーバーに有害コンポーネントがないこと、データが決して失われ・破損し・開示されないことは保証しません。本サービスはバックアップアーカイブではなく、専門的な医療・法律・財務助言、緊急サービス、法的・規制上の記録システムの代わりにはなりません（書面で明示的に合意した場合を除きます）。

他のユーザーが送信したコンテンツの正確性、合法性、品質について当社は責任を負いません。本サービスの利用およびいかなるコンテンツへの依拠は、お客様自身のリスクです。

12. 責任の制限

法令で認められる限り、当社、供給者、役員、従業員は、間接的、付随的、特別、結果的、懲罰的損害、逸失利益、収益、データ、のれん、機会の損失について責任を負いません。かかる損害の可能性が示されていた場合でも同様です。

本サービスまたは本規約に起因するすべての請求に対する当社の累計責任は、(a) 請求の直前 12 か月間に本サービスに支払った金額、または (b) 支払いがない場合は 50 ユーロのいずれか高い方を上限とします。契約、不法行為（過失を含む）、厳格責任など法理を問わず適用されますが、法令で禁止される場合（例：当社の過失による死亡・人身傷害、詐欺）は除きます。

お客様の法域で特定の制限が無効な場合、責任は法令で認められる最大限に制限されます。

13. 補償

当社の故意の不正行為を除き、お客様の利用、コンテンツ、または本規約違反に起因する請求、損害、損失、合理的な弁護士費用について当社を防御し補償します。

14. 終了

いつでも利用を中止できます。違反、セキュリティ上のリスク、未払い、または法的要件に基づき停止する場合があります。性質上存続すべき条項（責任制限、補償、準拠法）は終了後も存続します。

15. 変更

本規約および「最終更新日」を更新する場合があります。重大な変更は法令により追加の通知または同意が必要な場合があります。発効後の継続利用は、法令で別段の定めがない限り承諾とみなされます。

16. 準拠法および紛争

本規約は、本サービスを運営する者の登録上の本店または主たる事業所の所在国の法に準拠します。お客様の慣常的居住地国における強行の消費者保護規定には影響しません。

欧州経済領域に慣常的に居住する消費者の場合、法が定めるところにより居住地国の強行規定に依拠し、法が求める場合には居住地の裁判所に当社を訴えることができます。当社は、自らの事業所所在地の裁判所、または認められる範囲でお客様の居住国の裁判所に訴えを提起できます。

17. その他

いずれかの条項が無効でも残りは有効です。本規約、プライバシーポリシー、購入時に表示されるプラン固有の条件が、本サービスに関する完全な合意です。当社の同意なく権利を譲渡できません。当社は合併、買収、資産譲渡に関連して譲渡できるものとします。権利不行使は放棄を意味しません。合理的制御を超えた事由（不可抗力）による遅延・不履行について責任を負いません。

18. 連絡先

本規約に関するお問い合わせは、アプリ（例：About）またはウェブサイトに掲載の運営者連絡先へ。

最終更新：2026 年 3 月`,

  privacyFull: `1. はじめに

本プライバシーポリシーは、Duvpost の利用における個人データの取扱いを説明します。利用規約を補完します。

本サービスは小規模に運営されます。機能は拡大する場合があります（グループチャット、チャンネル、グループ通話、有料プラン、モデレーション）。本ポリシーは、展開された製品および合理的に予想される発展に沿った取扱いを記述します。

2. 管理者

お客様が利用する Duvpost 展開を運営する者（アプリ（例：About）またはドメインに記載）。請求は公開されている連絡先を使用してください。

3. 処理するデータ

利用に応じて：アカウント／認証、プロフィール／発見（People）、メッセージ（現状は主に 1 対 1；グループスレッドは追加時）、提供時はチャンネル、プランに応じた制限・保存期間を伴う添付、存在する場合はグループを含む通話／Meet、支払い／サブスクリプション、技術データ、App Check／reCAPTCHA、ローカルストレージ、リンクプレビュー。公開 AI モデルのトレーニングにチャット内容を使用しません。

4. 目的と法的根拠

契約の履行、セキュリティ、割当、保存、法的義務、取引メール、支払い。導入する場合はマーケティング／非必須 Cookie は別途同意。

5. 処理者

Google Firebase および関連 Google サービス。最新の一覧と文書：https://firebase.google.com/support/privacy および Google Cloud／Firebase のデータ処理条項。必要に応じ決済プロセッサ、ホスティング、メール。

6. 国境を越える移転

Google／Firebase で一般的な方法、例：標準契約条項。

7. 保存期間

チャットメッセージ（Firestore 上の暗号文）および Storage の添付は作成から 14 日間保存された後、自動削除されます。アカウント、プロフィール、連絡先などのサービスデータは、アカウントがアクティブで必要な間保持します。バックアップ／ログは限定的。アカウント削除後は可能な範囲で削除または匿名化。グループ／チャンネルデータは他メンバー側で製品ロジックに従います。

8. セキュリティ

HTTPS、ルール、クライアント側暗号化の可能性、App Check、ヘッダー — 技術文書を参照。

9. 個人データの侵害

当社が管理する個人データについて、偶発的または不法な破壊、紛失、変更、不正な開示をもたらすセキュリティ侵害を認識した場合、損害の軽減のため合理的な措置を講じ、法で義務付けられる場合は、遅滞なく監督当局および／または影響を受ける個人に通知します。

10. お客様の権利

所在地に応じて：アクセス、訂正、削除、制限、異議、ポータビリティ、監督当局への苦情。

11. 自動化された決定

法的効果または同等に重大な影響を生じる純粋に自動化された決定のために個人データを使用しません。別途法的根拠を示して通知する場合を除きます。

12. 児童

規約の最低年齢未満は対象外。

13. Cookie

ログイン／セッションに必須、その他は通知および該当する場合は同意の上で。

14. 変更

本ポリシーを更新する場合があります。

15. 連絡先

プライバシー請求は公開されている運営者連絡先へ。

最終更新：2026 年 3 月`,
} as const;
